import { getTranslations } from 'shared/utils/getTranslations';
import {
  DEFAULT_TIMELINE_PAGE_FUTURE_DESCRIPTION,
  DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION,
  FUTURE,
} from 'timeline/enums/constants';
import { t } from 'localization/utils/t';

const TP = 'timeline.utils.getTimelinePageHeader';

/**
 * [getTimelinePageHeader] returns the title and subtitle for the page from breadcrumbs or uses default title/subtitle values
 * @param timePeriod {string} - current selected time period
 * @param breadcrumbYears {{name: string}[]} - timeline years from breadcrumbs
 * @returns {{subtitle?: string, title: string}}
 */
export const getTimelinePageHeader = ({ timePeriod, breadcrumbYears }) => {
  // find year from breadcrumbs associated to currently selected timePeriod
  const currentYear = breadcrumbYears?.find((breadcrumbYear) => breadcrumbYear.name === timePeriod);
  const defaultTimelinePagePresentDescription = getTranslations(
    DEFAULT_TIMELINE_PAGE_PRESENT_DESCRIPTION,
  );
  const defaulTimlinePageFutureDescription = getTranslations(
    DEFAULT_TIMELINE_PAGE_FUTURE_DESCRIPTION,
  );
  // return description as subtitle if it exists
  if (currentYear) {
    return {
      title: currentYear.name,
      description: currentYear.description || defaultTimelinePagePresentDescription,
    };
  }

  return {
    title:
      timePeriod === FUTURE
        ? t(`${TP}.futureHeaderTitle`, 'Timeline: Upcoming Releases')
        : t(`${TP}.headerTitle`, 'Timeline: Sneaker Releases'),
    description:
      timePeriod === FUTURE
        ? defaulTimlinePageFutureDescription
        : defaultTimelinePagePresentDescription,
  };
};
